export const roleAccesscolumns = [
    { Header: 'Id', accessor: 'id'},
    { Header: 'User Name', accessor: 'userName' },
    { Header: 'Role Name', accessor: 'roleName' },
    { Header: 'Action', accessor: 'action' },
  ];

export const roleAccessTableData = [
    {
        id: '1',
        userName: 'Jone Pit',
        roleName: 'Manager',
    },
    {
        id: '2',
        userName: 'Jenny Dillow',
        roleName: 'Booking',
    },
    {
        id: '3',
        userName: 'Depo Pillo',
        roleName: 'Moderator',
    },
    {
        id: '4',
        userName: 'Jon Milla',
        roleName: 'Moderator',
    },
    {
        id: '5',
        userName: 'Jacky Jone',
        roleName: 'Moderator',
    },
    {
        id: '6',
        userName: 'Savan Marty',
        roleName: 'Moderator',
    },
    {
        id: '7',
        userName: 'Mom Killa',
        roleName: 'Booking',
    },
    {
        id: '8',
        userName: 'Hemu Ved',
        roleName: 'Booking',
    },
    {
        id: '9',
        userName: 'Josh Jerry',
        roleName: 'Booking',
    },
    {
        id: '10',
        userName: 'Harry Pit',
        roleName: 'Manager',
    },
]